import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/auth/AuthProvider';

export function SignedOutPage(): JSX.Element {
  const { signIn } = useAuth();
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>You are signed out</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            Federated sign-out complete. Close the tab or sign back in. Cockpit access is
            restricted to SO-Operator, SO-Supervisor, and SO-Admin members of the Techmer tenant.
          </p>
          <Button onClick={signIn}>Sign in again</Button>
        </CardContent>
      </Card>
    </div>
  );
}
